// Encodes an outlet id for customer site URLs (home and food list pages)
// so the real id is not shown in QR codes and links. The backend decodes it
// in getOutletsForCustomers / getFoodItemsForCustomers.
//
// Must stay identical to src/utils/outletLink.js in FoodOrder_FrontEnd and
// utils/outletLink.js in the backend. The output never contains "-", which
// the customer site uses to separate the outlet from seat/table details.
//
// This hides the id from casual viewing and URL guessing; it is not
// encryption, since the key ships in the browser code.
const OUTLET_LINK_KEY = "zutle-outlet-link";

export const encodeOutletId = (outletId) => {
  const id = String(outletId ?? "");
  if (!id) return "";
  let checksum = 0;
  let mixed = "";
  for (let i = 0; i < id.length; i++) {
    const code = id.charCodeAt(i);
    checksum = (checksum + code * (i + 1)) % 256;
    mixed += String.fromCharCode(
      code ^ OUTLET_LINK_KEY.charCodeAt(i % OUTLET_LINK_KEY.length)
    );
  }
  mixed += String.fromCharCode(checksum);
  return btoa(mixed).replace(/\+/g, "~").replace(/\//g, "_").replace(/=+$/, "");
};
